module.exports = __webpack_public_path__ + "img/img2.f7110a43.jpg";